/**
 * Lucide icons for the Civic Pass pins (screenshots/92, 102). civicPass.ts names each pin's icon with a lucide id
 * (TOPIC_PINS, "scroll-text" for bills); this maps the id to the component.
 */
import { Globe, House, KeyRound, Leaf, Map as MapIcon, Receipt, School, ScrollText, Shield, SquareParking, Store, Tag, TrainFront, UserRound, Utensils, type LucideIcon } from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  house: House, "key-round": KeyRound, utensils: Utensils, "square-parking": SquareParking, shield: Shield, receipt: Receipt,
  school: School, "train-front": TrainFront, globe: Globe, leaf: Leaf, store: Store, map: MapIcon, tag: Tag,
  "scroll-text": ScrollText, "user-round": UserRound,
};

export function PinIcon({ name, size = 16 }: { name: string; size?: number }) {
  const I = ICONS[name] ?? Tag;
  return <I size={size} aria-hidden />;
}
